<template>
  <div class="metafield-edit-custom-obj">
    <p class="metafield__title">{{ field.label }}</p>

    <RelationSetter
      :loading="loading"
      :items="customObjects"
      :value="value"
      unselectedLabel="Select custom object"
      selectedLabel="Selected custom objects"
      :linkUrl="linkUrl"
      @input="onInput"
    ></RelationSetter>

    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
import RelationSetter from '@/components/RelationSetter'
import { last } from 'lodash'
import { mapGetters } from 'vuex'
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  components: {
    RelationSetter
  },
  props: {
    field: Object,
    value: { default: () => [] },
    hint: String,
    subFormData: Object
  },
  data () {
    return {
      loading: true,
      customObjects: null,
      groupKey: null
    }
  },
  computed: {
    ...mapGetters('cacheMetafields', [
      'cachedCustomObjs',
      'isRequestPending',
    ]),
    showLoader () {
      return this.isRequestPending[this.groupKey] || this.loading
    }
  },
  watch: {
    cachedCustomObjs: {
      handler () {
        this.initData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onInput (val) {
      this.$emit('input', val)
    },
    linkUrl (item) {
      const item_id = last(item.key.split(this.groupKey))
      return `/customobjects/edit?key=${item_id}&id=${this.subFormData.groupID}`
    },
    initData () {
      const { groupID } = this.subFormData

      if (this.cachedCustomObjs && this.cachedCustomObjs[groupID] && !this.customObjects) {
        const { groupKey, customObjects } = this.cachedCustomObjs[groupID]
        this.groupKey = groupKey
        this.customObjects = customObjects
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';

  .metafield-edit-custom-obj {
    display: block;

    .metafield__title {
      margin-bottom: 20px;
    }

    .TypographyInputHint {
      margin-top: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditCustomObject.vue